module.exports = __webpack_public_path__ + "static/img/nocontent.25497f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/no/nocontent.png
// module id = n9Ti
// module chunks = 11